module.exports = __webpack_public_path__ + "static/img/guoyao-logo2.227c07db.png";